import React, { Component } from 'react';
import { Form } from 'antd'

import InputCustom from '../../components/default/InputCustom'
import ButtonCustom from '../../components/default/ButtonCustom'

import { connect } from 'react-redux'
import { updatePassword } from '../../actions/account'

class ChangePassword extends Component {
	state = {
        password: {
            password: "",
            new_password: "",
            confirm_password: "",
        }
    }

	onSubmit = (e) => {
        e.preventDefault()
		let password = { ...this.state.password }
        this.props.updatePassword(password)
	}

	onInputChange = (event) => {
        const name = event.target.name
        let password = { ...this.state.password }
        password[name] = event.target.value
        this.setState({password: password})
	}
    render() {
        return (
            <div className="new-topic-page-wrap">
                <div className="new-topic-page-title gapb-32">เปลี่ยนรหัสผ่าน</div>
                <div className="new-topic-page">
                    <div className="new-topic-title gapb-24">ข้อมูลรหัสผ่าน</div>
                    <Form onSubmit={this.onSubmit}>
						<InputCustom
							label="รหัสผ่านปัจจุบัน"
							placeholder="รหัสผ่านปัจจุบัน"
							size="large"
							type="password"
							required
							marginBottom="16"
							name="password"
							onChange={this.onInputChange} />
						<InputCustom
							label="รหัสผ่านใหม่"
							placeholder="รหัสผ่านใหม่"
							size="large"
							type="password"
							required
							marginBottom="16"
							name="new_password"
							onChange={this.onInputChange} />
						<InputCustom
							label="ยืนยันรหัสผ่านใหม่"
							placeholder="ยืนยันรหัสผ่านใหม่"
							size="large"
							type="password"
							required
							marginBottom="0"
							name="confirm_password"
							onChange={this.onInputChange} />
						<div className="is-row is-sm-row-reverse gapt-32 flex-end">
							<div className="gapr-12 sm-gapr-0 is-sm-100" style={{ width: 160}}>
								<ButtonCustom
									borderRadius="4"
									color="outline-white"
									label="ยกเลิก"
									size="large"
									fontSize={16}
									href="/account" />
							</div>
							<div className="is-sm-100 sm-gapb-12" style={{ width: 160 }}>
								<ButtonCustom
									borderRadius="4"
									color="blue"
									label="ยืนยัน"
									size="large"
									fontSize={16}
									htmlType="submit" />
							</div>
						</div>
                    </Form>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return{
        auth: state.auth,
        account: state.account
    }
}

const mapDispatchToProps = {
	updatePassword
}

export default connect(mapStateToProps,mapDispatchToProps)(ChangePassword)
